module.exports = __webpack_public_path__ + "static/media/gemini.fb35fe5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/gemini.svg
// module id = 102
// module chunks = 0